import { RefObject } from 'react';
import { toHtml, icon } from '@fortawesome/fontawesome-svg-core';

const ROUND_WITH_DECIMALS = 10;

export const fitSVGToParent = (
  svgNode: SVGSVGElement,
  parentRef: RefObject<HTMLDivElement>,
  scale?: number
): { scaleFactor: number } => {
  const parentContainerDimensions = getParentDimensions(parentRef);

  const scaleFactor = getSvgScaleFactor(parentContainerDimensions, svgNode, scale);
  scaleSVG(svgNode, scaleFactor);
  return { scaleFactor };
};

export const getParentDimensions = ({ current }) =>
  current ? current.getBoundingClientRect() : null;

export const getSvgScaleFactor = (
  parentDimensions: { width: number; height: number },
  svgNode,
  scale?: number
): number => {
  const width = parentDimensions.width / (scale ?? 1);
  const height = parentDimensions.height / (scale ?? 1);

  const baseSVGDimensions = getSvgBaseDimensions(svgNode);
  let scaleFactor = baseSVGDimensions.height / height;

  if (width && baseSVGDimensions.width / scaleFactor > width) {
    scaleFactor = baseSVGDimensions.width / width;
  }

  return Math.round(scaleFactor * ROUND_WITH_DECIMALS) / ROUND_WITH_DECIMALS;
};

export const getSvgBaseDimensions = (
  svgNode: SVGSVGElement | null
): { width: number; height: number } => {
  const viewbox = svgNode?.getAttribute('viewBox');

  return {
    width: parseInt(viewbox?.split(' ')[2] || '0', 10),
    height: parseInt(viewbox?.split(' ')[3] || '0', 10),
  };
};

export const getSvgScaledDimensions = (
  { width, height },
  scaleFactor: number
): { width: number; height: number } => ({
  width: width / scaleFactor,
  height: height / scaleFactor,
});

export const scaleSVG = (svgNode: SVGSVGElement | null, scaleFactor: number) => {
  const { width, height } = getSvgScaledDimensions(getSvgBaseDimensions(svgNode), scaleFactor);

  svgNode?.setAttribute('width', width.toString());
  svgNode?.setAttribute('height', height.toString());
};

export const convertSVGIconToImageUri = (faIcon, color) => {
  const abstract = icon(faIcon).abstract[0];
  if (!abstract.children?.length) return undefined;
  if (color) abstract.children[0].attributes.fill = color;
  return `data:image/svg+xml;base64,${btoa(toHtml(abstract))}`;
};
